import { Box } from '@material-ui/core';
import React, { useContext } from 'react';
import { DetailListContext } from '../DetailList/DetailList';
import { Typography } from '../Typography';
import DetailListItemEmptyState from '../DetailListItemEmptyState';
import clsx from 'clsx';
/**
 * Renders an individual item inside a `DetailList` component.
 */
const DetailListItem = props => {
    const { itemClassName, isInline, itemSize, centeredList } = useContext(DetailListContext);
    const { content, fullWidth: fullWidthProp, label, isEmpty, children, className, size: sizeProp, center: centerProp, caption, ...rest } = props;
    const fullWidth = isInline || fullWidthProp;
    const size = itemSize || (isInline && !sizeProp ? 'medium' : sizeProp);
    const center = typeof centeredList === 'undefined' ? centerProp : centeredList;
    const flexDirection = fullWidth ? 'column' : 'row';
    const contentAlign = fullWidth ? 'left' : 'right';
    const contentToRender = content || children;
    const Caption = () => (React.createElement(Typography, { component: "span", variant: "caption", color: "textSecondary", fontWeight: "regular" }, caption));
    let contentAlignItems = 'flex-start';
    if (!fullWidth) {
        contentAlignItems = 'flex-end';
    }
    if (isInline && center) {
        contentAlignItems = 'center';
    }
    const isMediumOrLarge = size && ['medium', 'large'].includes(size);
    const labelVariant = isMediumOrLarge ? 'body2' : 'caption';
    const labelFontWeight = isMediumOrLarge ? 'medium' : 'light';
    const labelIsCustom = typeof label !== 'string';
    const labelContainerProps = {
        my: 0.5,
        mr: fullWidth ? 0 : 1,
        ...(labelIsCustom
            ? {}
            : {
                display: 'flex',
                justifyContent: isInline && center ? 'center' : 'normal',
            }),
    };
    const contentIsCustom = !isEmpty && typeof contentToRender !== 'string';
    const contentContainerProps = {
        width: '100%',
        ...(contentIsCustom
            ? {}
            : {
                display: 'flex',
                flexGrow: fullWidth ? 1 : undefined,
                justifyContent: center ? 'center' : 'normal',
            }),
    };
    return (React.createElement(Box, Object.assign({ component: "li", display: "flex", flexDirection: flexDirection, justifyContent: isInline ? 'flex-start' : 'space-between', pt: 1, pb: 1, className: clsx(className, itemClassName) }, rest),
        React.createElement(Box, Object.assign({}, labelContainerProps), typeof label === 'string' ? (React.createElement(Box, { whiteSpace: "nowrap" },
            React.createElement(Typography, { component: "span", variant: labelVariant, fontWeight: labelFontWeight, color: "textSecondary" }, label))) : (label)),
        React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: contentAlignItems, justifyContent: "center" },
            React.createElement(Box, Object.assign({}, contentContainerProps),
                isEmpty && React.createElement(DetailListItemEmptyState, null),
                !isEmpty && typeof contentToRender === 'string' && (React.createElement(Typography, { component: "span", align: contentAlign, variant: size === 'large' ? 'h6' : 'body1' }, contentToRender)),
                !isEmpty && typeof contentToRender !== 'string' && contentToRender),
            !isEmpty && caption && React.createElement(Caption, null))));
};
export default DetailListItem;
//# sourceMappingURL=DetailListItem.js.map